import styled from "styled-components";
import { FlexRow } from "styles/layout";
import { Theme } from "theme";

export const BracketPicksContainer = styled.div`
  border-bottom: ${Theme.panelContentBorder};
  &:last-child {
    border-bottom: 0;
  }
`;
export const GroupOrgLogoContainer = styled.div`
  height: 28px;
  width: 30px;

  @media (max-width: 700px) {
    width: 24px;
    height: 26px;
  }
`;

export const GroupOrgName = styled.div`
  width: 190px;
  font-size: 12pt;
  margin-left: 8px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow-x: clip;

  @media (max-width: 700px) {
    font-size: 12pt;
    width: 160px;
  }

  @media (max-width: 450px) {
    width: 140px;
  }
`;

export const GroupHeader = styled.th`
  width: 80px;
  text-align: center;
`;

export const GroupCell = styled.td`
  text-align: center;
`;

export const GroupTable = styled.table`
  border-spacing: 0;
  border-collapse: collapse;
  margin: auto;
  width: 100%;
`;

export const GroupHeaderRow = styled.tr`
  background: ${Theme.tabBackground};

  th {
    border-bottom: ${Theme.panelContentBorder};

    &:first-child {
      padding-left: ${Theme.bigPanelPaddingHorizontal};

      @media (max-width: 700px) {
        padding-left: ${Theme.smallPanelPadding};
      }
    }

    &:last-child {
      padding-right: ${Theme.bigPanelPaddingHorizontal};

      @media (max-width: 700px) {
        padding-right: ${Theme.smallPanelPadding};
      }
    }
  }
`;

export const GroupRow = styled.tr`
  td {
    border-bottom: ${Theme.panelContentBorder};
    padding: 5px 0;

    &:first-child {
      padding-left: ${Theme.bigPanelPaddingHorizontal};

      @media (max-width: 700px) {
        padding-left: ${Theme.smallPanelPadding};
      }
    }

    &:last-child {
      padding-right: ${Theme.bigPanelPaddingHorizontal};

      @media (max-width: 700px) {
        padding-right: ${Theme.smallPanelPadding};
      }
    }
  }

  &:last-child {
    td {
      border-bottom: 0;
    }
  }
`;

export const RankemDriverPicksContainer = styled(FlexRow)`
  padding-top: "18px";
  border-top: ${Theme.panelContentBorderStrong};
`;
